<a href="{{ helpPath }}" target="_blank" id="fa-icon" style="text-decoration: none" [ngClass]="'fas fa-circle-question icon-teal ' + customClass">

</a>